module.exports = __webpack_public_path__ + "img/130ne.8e81efd3.svg";